// @flow

import { type ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  getMake,
  getModel,
  getDescription,
  getEngine,
  getPower,
  getFueltype,
  getPrice,
  getDefaultImageUrl,
  getDiscountPrice,
  getConfigLink,
  getInfoLink,
  getReservation,
  isAvailable,
  getName as getPackageName,
} from '../../../store/pdb/selectors';
import {
  getPriceLabel,
  getPriceDuration,
  getDeliveryText,
  getReserved,
  getNotAvailableText,
  getButtonText,
} from '../../../store/componentSettings/selectors/carBlockSettings';
import type { StateProps } from '../types';
import withErrorBoundary from '../../withErrorBoundary';
import { buildRemarkText } from '../../../helpers';

type OwnProps = {|
  pdbId: string,
  queryData?: Object,
  packageId: string,
|};

export const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => ({
  basePrice: getPrice(state, ownProps.pdbId, ownProps.packageId),
  configLink: getConfigLink(state, ownProps.pdbId, ownProps.queryData || {}),
  consumerPrice: getDiscountPrice(state, ownProps.pdbId, ownProps.packageId),
  defaultImage: getDefaultImageUrl(state, ownProps.pdbId, ownProps.packageId),
  deliveryText: getDeliveryText(state, ownProps.pdbId, ownProps.packageId),
  descriptionText: getDescription(state, ownProps.pdbId),
  engine: getEngine(state, ownProps.pdbId, 0, ownProps.packageId),
  fueltype: getFueltype(state, ownProps.pdbId),
  isAvailable: isAvailable(state, ownProps.pdbId),
  isReserved: getReservation(state, ownProps.pdbId),
  make: getMake(state, ownProps.pdbId),
  model: getModel(state, ownProps.pdbId),
  modelInfoLink: getInfoLink(state, ownProps.pdbId, ownProps.queryData || {}),
  notAvailableText: getNotAvailableText(state),
  paymentText: `${getPriceLabel(state)} ${getPriceDuration(state)}`,
  remarkText: buildRemarkText(state, ownProps.pdbId),
  packageName: getPackageName(state, ownProps.packageId, ownProps.pdbId) || '',
  power: getPower(state, ownProps.pdbId, 0, ownProps.packageId),
  reservedText: getReserved(state),
  buttonText: getButtonText(state),
  ...ownProps, // allow stateProps to be overriden by ownProps e.g.: a custom configLink
});

const withCarblockProps = (CarBlockComponent: ComponentType<*>) => (
  withErrorBoundary<any, any, OwnProps, any, any>(connect(mapStateToProps)(CarBlockComponent))
);

export default withCarblockProps;
